/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The GetUploadStatusResponse model module.
* @module model/GetUploadStatusResponse
* @version 2020-12-7
*/
export default class GetUploadStatusResponse {
    /**
    * Constructs a new <code>GetUploadStatusResponse</code>.
    * @alias module:model/GetUploadStatusResponse
    * @class
    * @param status {String} 現状
    * @param done {Number} 実数値
    * @param total {Number} 総数
    * @param timestamp {Number} 時刻
    * @param result {module:model/GetUploadStatusResponse.ResultEnum} 
    */

    constructor(status, done, total, timestamp, result) {
        
        
        this['status'] = status;
        this['done'] = done;
        this['total'] = total;
        this['timestamp'] = timestamp;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>GetUploadStatusResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GetUploadStatusResponse} obj Optional instance to populate.
    * @return {module:model/GetUploadStatusResponse} The populated <code>GetUploadStatusResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetUploadStatusResponse();
                        
            
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('done')) {
                obj['done'] = ApiClient.convertToType(data['done'], 'Number');
            }
            if (data.hasOwnProperty('total')) {
                obj['total'] = ApiClient.convertToType(data['total'], 'Number');
            }
            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Number');
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * 現状
    * @member {String} status
    */
    'status' = undefined;
    /**
    * 実数値
    * @member {Number} done
    */
    'done' = undefined;
    /**
    * 総数
    * @member {Number} total
    */
    'total' = undefined;
    /**
    * 時刻
    * @member {Number} timestamp
    */
    'timestamp' = undefined;
    /**
    * @member {module:model/GetUploadStatusResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
